import type { ProviderKey } from '@littlebird/integrations';

export const INTEGRATION_MANAGEMENT_HASH = 'settings/Integrations/manage';

// Kept separate from `settings-search.config.ts` so `SettingsSection.Item`
// doesn't eagerly pull the full search manifest (menu config, Electron shared
// constants, shortcut registry)

/** DOM id `SettingsSection.Item` renders for a row annotated with `searchId` */
export const settingsItemDomId = (searchId: string) =>
  `settings-item-${searchId}`;

// Search-entry ids for dynamic rows. The providers and the panes both build
// them from these helpers so the id a deep-link hash carries always matches
// the anchor the pane renders

export const shortcutSearchId = (shortcutId: string) =>
  `keyboard-shortcuts.${shortcutId}`;

export const integrationSearchId = (toolkitName: string) =>
  `integrations.${toolkitName}`;

export const mcpClientSearchId = (grantId: string) => `mcp-clients.${grantId}`;

export const archivedChatSearchId = (threadId: string) =>
  `archived-chats.${threadId}`;

const INTEGRATION_PROVIDER_SEARCH_ID_PREFIX = 'integrations.provider.';

/** Search id for a unified `IntegrationProvider`. Keeps `providerKey` opaque —
 * encodes/decodes it whole, never parses its namespace */
export const integrationManagementSearchId = (providerKey: ProviderKey) =>
  `${INTEGRATION_PROVIDER_SEARCH_ID_PREFIX}${encodeURIComponent(providerKey)}`;

export function providerKeyFromIntegrationSearchId(
  searchId: string
): ProviderKey | null {
  if (!searchId.startsWith(INTEGRATION_PROVIDER_SEARCH_ID_PREFIX)) return null;
  const encoded = searchId.slice(INTEGRATION_PROVIDER_SEARCH_ID_PREFIX.length);
  if (!encoded) return null;
  try {
    return decodeURIComponent(encoded) as ProviderKey;
  } catch {
    return null;
  }
}
